import React, { Component } from 'react'
import {connect} from 'react-redux'
import Validate from './Validate'

import DualRing from '../DualRing'

class AuthLayout extends Component {
  render () {
    const { list } = this.props.fiscalyear
    if (list === null) {
      return <DualRing />
    } else {
      return (
        <div>
          <Validate />
          {this.props.children}
        </div>
      )
    }
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { })(AuthLayout)



// WEBPACK FOOTER //
// ./src/components/Bone/AuthLayout.js